const CALL = 'call';
const OMNI = 'omni';
const SMS = 'sms';
const WHATSAPP = 'whatsapp';
const OTP = 'otp-inverse';
const EMAIL = 'email';

export {
    CALL,
    OMNI,
    SMS,
    WHATSAPP,
    OTP,
    EMAIL
};
